import React, {Component} from "react";
import PropTypes from "prop-types";
import PhaseListItem from "./PhaseListItem";
import PhaseModel from "../models/phase";
import Octicon, {Plus} from "@github/octicons-react";
import Modal from "./Modal";

export default class PhaseList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalVisible: false
        };
    }

    renderPhases() {
         if (this.props.phases === undefined) {
            return;
        }

        let phases = [];

        this.props.phases.forEach((phase) => {
            phases.push(<PhaseListItem
                key={phase.id}
                model={phase}
                onDelete={this.props.onDeletePhase}
            />);
        });

        return phases;
    }

    toggleCreateForm = () => {
        console.log('toggling modal visible state');
        this.setState({modalVisible: !this.state.modalVisible});
    };

    render() {
        return (
            <div className="mt-3">
                <Modal visible={this.state.modalVisible} toggleCallback={() => this.toggleCreateForm()}/>
                <h5>Phasen <button onClick={this.toggleCreateForm} type="button" className="btn btn-outline-success btn-sm align-text-bottom"><Octicon icon={Plus}/></button></h5>
                <ul className="list-group">
                    {this.renderPhases()}
                </ul>
            </div>
        )
    }
}

PhaseList.propTypes = {
    phases: PropTypes.arrayOf(PropTypes.instanceOf(PhaseModel)).isRequired,
    onDeletePhase: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/PhaseList.js